import Vue from "vue";
import CompanyService from "@/service/CompanyService";
import MenuRightSerivce from "@/service/MenuRightService";
import SweetAlertService from "@/service/SweetAlertService";
import StaffService from "@/service/StaffService";
import StaffEmploymentService from "@/service/StaffEmploymentService";
import StoreGetter from "@/constants/StoreGetter";
import { Team } from "@/model/Team";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import Setting from "@/constants/Settings";
import TeamValidation from "./S081600-TeamValidation.js";
import Paginate from "vuejs-paginate";
var TeamObj = new TeamValidation();
export default {
    name: "Team",
    mounted() {
        TeamObj.TeamValidation();
        this.assignRights();
        this.getAllDepartment();
        this.getAllTeam();
    },
    components: {
        paginate: Paginate,
    },
    data: () => ({
        menuRights: { allRights: {}, rightsForThisMenu: {} },
        menuId: Setting.MenuID.S_Team,
        dictEnum: dictEnum,
        Team: new Team(),
        isEditMode: false,
        TeamList: [],
        DepartmentList: [],
        selectAllTeam: false,
        tempTeamModel: new Team(),
    }),
    computed: {
        t() {
            return t;
        },
        user() {
            return this.$store.getters[StoreGetter.user];
        },
    },
    methods: {
        hasRight(key, menuId) {
            if (Object.keys(this.menuRights.allRights).length === 0) {
                return false;
            } else {
                return MenuRightSerivce.hasRightInMenu(
                    this.menuRights.allRights,
                    menuId ? menuId : this.menuId,
                    key
                );
            }
        },
        assignRights() {
            this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
            this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
                x => x.MenuID == this.menuId
            );
        },
        async getAllDepartment() {
            var self = this;
            var obj = {}
            const response = await StaffEmploymentService.getAllDepartment(obj);
            if (response.data.IsSuccess) {
                self.DepartmentList = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        async getAllTeam() {
            var self = this;
            var obj = {}
            const response = await StaffEmploymentService.getAllTeams(obj);
            if (response.data.IsSuccess) {
                self.TeamList = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        selectAllTeamRecord: function () {
            var self = this;
            var IsSelected = self.selectAllTeam;
            self.TeamList.forEach(function (val, index) {
                val["isSelected"] = IsSelected;
            });
        },
        deleteMultipleTeamPopup: function () {
            var arrayList = [];
            var self = this;
            self.TeamList.forEach(function (key, value) {
                if (key.isSelected) {
                    arrayList.push(key);
                }
            });
            if (arrayList.length > 0) {
                $('#deleteTeamListModel').modal('show');
            }
            else {
                SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectDeleteRecord));
            }
        },
        async deleteMultipleTeam() {
            var arrayList = [];
            var self = this;
            $('#deleteTeamListModel').modal('hide');
            self.TeamList.forEach(function (key, value) {
                if (key.isSelected) {
                    arrayList.push(key);
                }
            });
            const obj = {
                teamList: arrayList,
            };
            const response = await StaffEmploymentService.deleteTeams(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetTeam();
                await self.getAllTeam();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        OnTeamSelect: function (model) {
            this.tempTeamModel = model;
        },
        addTeam: function () {
            var self = this;
            $('#TeamModel').modal('show');
            self.isEditMode = false;
            self.Team = new Team();
            self.$validator.reset();
            self.vErrors.clear();
        },
        async saveTeamDetail(obj) {
            var self = this;
            const response = await StaffEmploymentService.addTeam(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetTeam();
                await self.getAllTeam();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        async editTeam(obj) {
            var self = this;
            const response = await StaffEmploymentService.updateTeam(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetTeam();
                await self.getAllTeam();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        async saveTeam() {
            var self = this;
            self.$validator.validateAll().then(result => {
                if (result) {
                    $('#TeamModel').modal('hide');
                    const obj = {
                        model: {
                            Dept: self.Team.Dept,
                            TeamCode: self.Team.TeamCode,
                            CDesc: self.Team.CDesc,
                            EDesc: self.Team.EDesc,
                        }
                    };
                    if (self.isEditMode) {
                        self.editTeam(obj);
                    }
                    else {
                        self.saveTeamDetail(obj);
                    }
                }
            });
        },
        async editTeamDetail() {
            var self = this;
            self.isEditMode = true;
            if (self.tempTeamModel.TeamCode != "") {
                self.Team = this.tempTeamModel;
                self.$validator.reset();
                self.vErrors.clear();
                $('#TeamModel').modal('show');
            }
            else {
                SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectEditRecord));
            }
        },
        resetTeam: function () {
            var self = this;
            self.selectAllTeam = false;
            self.isEditMode = false;
            self.Team = new Team();
            self.tempTeamModel = new Team();
            self.$validator.reset();
            self.vErrors.clear();
        },
        closeTeamPopup: function () {
            var self = this;
            self.selectAllTeam = false;
            self.isEditMode = false;
            self.Team = new Team();
            self.tempTeamModel = new Team();
            self.$validator.reset();
            self.vErrors.clear();
            $('#TeamModel').modal('hide');
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S081600-Team/S081600-Team.js